import { MainContentBotList } from "./components/botlist/MainContentBotList";
import Layout from "./components/ui/Layout";

export const BotList = () => {
  return (
    <Layout>
      <MainContentBotList />
    </Layout>
  );
};
